<template>
    <div>
        <!-- ======= Footer ======= -->
        <footer id="footer">
<!--            <div class="footer-top">-->
<!--                <div class="container">-->
<!--                    <div class="row">-->

<!--                        <div class="col-lg-3 col-md-6 footer-info">-->
<!--                            <h3>PharmaPLUS</h3>-->
<!--                            <p>Cras fermentum odio eu feugiat lide par naso tierra. Justo eget nada terra videa magna derita valies darta donna mare fermentum iaculis eu non diam phasellus. Scelerisque felis imperdiet proin fermentum leo. Amet volutpat consequat mauris nunc congue.</p>-->
<!--                        </div>-->

<!--                        <div class="col-lg-3 col-md-6 footer-links">-->
<!--                            <h4>Useful Links</h4>-->
<!--                            <ul>-->
<!--                                <li><i class="ion-ios-arrow-right"></i> <a href="#">Home</a></li>-->
<!--                                <li><i class="ion-ios-arrow-right"></i> <a href="#">About us</a></li>-->
<!--                                <li><i class="ion-ios-arrow-right"></i> <a href="#">Services</a></li>-->
<!--                                <li><i class="ion-ios-arrow-right"></i> <a href="#">Terms of service</a></li>-->
<!--                                <li><i class="ion-ios-arrow-right"></i> <a href="#">Privacy policy</a></li>-->
<!--                            </ul>-->
<!--                        </div>-->

<!--                        <div class="col-lg-3 col-md-6 footer-contact">-->
<!--                            <h4>Contact Us</h4>-->
<!--                            <p>-->
<!--                                A108 Adam Street <br>-->
<!--                                New York, NY 535022<br>-->
<!--                                United States <br>-->
<!--                                <strong>Phone:</strong> +1 5589 55488 55<br>-->
<!--                                <strong>Email:</strong> info@example.com<br>-->
<!--                            </p>-->

<!--                            <div class="social-links">-->
<!--                                <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>-->
<!--                                <a href="#" class="facebook"><i class="fa fa-facebook"></i></a>-->
<!--                                <a href="#" class="instagram"><i class="fa fa-instagram"></i></a>-->
<!--                                <a href="#" class="google-plus"><i class="fa fa-google-plus"></i></a>-->
<!--                                <a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a>-->
<!--                            </div>-->

<!--                        </div>-->

<!--                        <div class="col-lg-3 col-md-6 footer-newsletter">-->
<!--                            <h4>Our Newsletter</h4>-->
<!--                            <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna veniam enim veniam illum dolore legam minim quorum culpa amet magna export quem marada parida nodela caramase seza.</p>-->
<!--                            <form action="" method="post">-->
<!--                                <input type="email" name="email"><input type="submit" value="Subscribe">-->
<!--                            </form>-->
<!--                        </div>-->

<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <div class="container">
                <div class="copyright">
                    &copy; Copyright <strong>PharmaPLUS</strong>. All Rights Reserved
                </div>
                <div class="credits" style="color: #000000">
                    <!--
                    All the links in the footer should remain intact.
                    You can delete the links only if you purchased the pro version.
                    Licensing information: https://bootstrapmade.com/license/
                    Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/buy/?theme=BizPage
                  -->
                    Designed by
                    <a style="color: #000000" href="https://mdprog.com/" target="_blank">mdprog</a>
                </div>
            </div>
        </footer><!-- End Footer -->
    </div>
</template>

<script>
    import {  mdbFooter } from "mdbvue";
    export default {
        name: "FooterComponent",
        components:{
            mdbFooter
        }
    }
</script>

<style scoped>

</style>